module.exports = __webpack_public_path__ + "media/images/emblems/Elsau-blazon-23ac5617669a942f522b6b9d482ea506.svg";